// Build information - Updated automatically on each deployment
// Last updated: 19.04.2026 14:20

export const BUILD_INFO = {
  version: '2.4.0',
  buildDate: '2026-04-19T14:20:00Z',
  buildTimestamp: new Date('2026-04-19T14:20:00Z').getTime()
};

// Helper to format build date
export const getFormattedBuildDate = () => {
  const date = new Date(BUILD_INFO.buildDate);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  
  return `${day}.${month}.${year} ${hours}:${minutes}`;
};
